<div class="d-flex justify-content-space-between align-items-center">
  <app-date-filter [config]="config.fromFilter"
                   [controlName]="config.fromFilter.controlName"
                   [form]="form"
                   [class.sm]="sm"></app-date-filter>

  <span class="filter-separator">—</span>

  <app-date-filter [config]="config.toFilter"
                   [controlName]="config.toFilter.controlName"
                   [form]="form"
                   [class.sm]="sm"></app-date-filter>
</div>
<button *ngIf="config.todayBtn" mat-ripple (click)="setTodayDateTime()"
        [attr.data-test-id]="config.testId + '-today-btn'"
        class="chip chip_def">Cьогодні
</button>
